import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import AspectRatio from 'react-aspect-ratio';
import TextTruncate from 'react-text-truncate';
import { convertYouTubeIdToImg } from 'appSrc/utils';
import ListCoverImage from 'appSrc/components/List/CoverImage';
import { UserAvatar, Icon } from 'appSrc/components/UI';
import TheaterPlayIcon from 'appSrc/components/Shards/Theater/PlayIcon';
import style from './styles/style.module.css';

class TransformingSmallListCard extends PureComponent {
    constructor( props ) {
        super( props );

        const { list } = props;

        this.state = {
            listSlug: '/' + list.author.slug + '/' + list.slug,
            hasVideo: !!list.youtube,
        };
    }
    renderCoverImage = ( list ) => {
        var coverImage = list.coverImage || convertYouTubeIdToImg( list.youtube );
        return (
            <ListCoverImage coverImage={ coverImage } />
        );
    }
    render() {
        const { list } = this.props;
        const { listSlug, hasVideo } = this.state;

        const author = list.author || {};
        const profession = ( author.profession || {} ).title;

        const category = list.interests[0] ? list.interests[0].interest : '';

        const movieMetaData = {
            attached_to: 'list_cover_video',
            attached_id: list.listid,
            video_author_id: author.userid,
        };

        var countMessage = list.desires.length.toString() + ' Product';
        countMessage += list.desires.length > 1 ? 's' : '';

        return (
            <div className={ `${ style.smallListCard } ${ this.props.className }`.trim() }>
                <Link to={ listSlug } className={ style.backgroundLink }></Link>
                <div className={ style.cardContent }>
                    <AspectRatio ratio='10/9'
                    className={ style.aspectRatio }>
                        <div>
                            <div className={ style.imageWrapper }>
                                { this.renderCoverImage( list ) }
                            </div>
                            <div className={ style.overlayInfo }>
                                { hasVideo &&
                                    <TheaterPlayIcon className={ style.playButton } youtubeId={ list.youtube }
                                    metaData={ movieMetaData } />
                                }
                                { list.desires.length > 0 &&
                                    <div className={ style.productCount }>
                                        <Icon source='customSvg' icon='bag' size={ 16 } />
                                        <span>{ countMessage }</span>
                                    </div>
                                }
                            </div>
                        </div>
                    </AspectRatio>
                    <div className={ style.cardInfo }>
                        <div className={ style.listCategory } title={ category }>{ category }</div>
                        <TextTruncate text={ list.title }
                        title={ list.title } line={ 2 }
                        containerClassName={ style.listTitle } />
                        <TextTruncate text={ list.description }
                        title={ list.description } line={ 2 }
                        containerClassName={ style.description } />
                        <div className={ style.authorInfo }>
                            <UserAvatar src={ author.avatar } size={ 30 } />
                            <div className={ style.infoText }>
                                { profession &&
                                    <div className={ style.profession } title={ profession }>{ profession }</div>
                                }
                                <div className={ style.displayName } title={ author.displayName }>{ author.displayName }</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
TransformingSmallListCard.propTypes = {
    list: PropTypes.object.isRequired,
};
TransformingSmallListCard.defaultProps = {
    className: '',
};

export default TransformingSmallListCard;
